import { render, staticRenderFns } from "./MissionDetailFtp.vue?vue&type=template&id=2055be84"
import script from "./MissionDetailFtp.vue?vue&type=script&setup=true&lang=ts"
export * from "./MissionDetailFtp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MissionDetailFtp.vue?vue&type=style&index=0&id=2055be84&prod&scope=true&lang=css"
import style1 from "./MissionDetailFtp.vue?vue&type=style&index=1&id=2055be84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports